/** 서비스 환경 확인 함수 */
export const getEnvironmentConfig = () => {
  // 스테이징 환경인지 확인
  const isStaging = process.env.VUE_APP_NODE_ENV === 'staging' || 
                   window.location.hostname.includes('staging');
  
  return {
    isStaging,
    isProduction: !isStaging,
    headerBackgroundColor: isStaging ? '#EC0047' : '#333',
  };
}; 